var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('jobItemTest',{attrs:{"is-selected":_vm.selectedItem}}),_c('jobItemTest',{attrs:{"is-selected":_vm.selectedItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }